import Myfeedimage from "./images/Home_(My_Feed).png"
import LibraryImage from "./images/Library.png"
import Calendarimage from "./images/Calendar.png"
import SummaryImg from "./images/Summary.png"
import AssessmentImg from "./images/Assessment_Icon.png"
import SelfAssessmentImg from "./images/Self-Assessment.png"
import HomeworkImg from './images/Homework.jpg'
import PreReadImg from "./images/Pre_Read.png"
import ActivityImg from './images/Activity.png'
import CommunityImg from "./images/Community_group.png"
import QueryImg from "./images/Query_group.png"

import DashboaredIcon from './images/dashboard.svg'
import DashboaredActiveIcon from './images/dashboard-active.svg'
import DashboaredActiveFooterIcon from './images/dashboard-footer.svg'
import ContentLibraryIcon from './images/content-library.svg'
import ContentLibraryActiveIcon from './images/content-library-active.svg'
import CalendarIcon from './images/calendar.svg'
import CalendarActiveIcon from './images/calendar-active.svg'
import AttendanceIcon from './images/attendance.svg'
import AttendanceActiveIcon from './images/attendance-active.svg'
import SummaryIcon from './images/lecture-management.svg'
import SummaryActiveIcon from './images/lecture-management-active.svg'
import AssessmentIcon from './images/assessment.svg'
import AssessmentActiveIcon from './images/assessment-active.svg'
import AssignmentIcon from './images/assignment.svg'
import AssignmentActiveIcon from './images/assignment-active.svg'
import EngagementIcon from './images/engagement.svg'
import EngagementActiveIcon from './images/engagement-active.svg'
import PerformanceIcon from './images/performance.svg'
import PerformanceActiveIcon from './images/performance-active.svg'
import CrossIcon from './images/close.svg'
import LikeIcon from './images/like.svg'
import CommentIcon from './images/comment.svg'
import LikeActiveIcon from './images/like-active.svg'
import UploadIcon from './images/upload.svg'




const assets = {
    Myfeedimage,
    LibraryImage,
    Calendarimage,
    SummaryImg,
    AssessmentImg,
    SelfAssessmentImg,
    HomeworkImg,
    PreReadImg,
    ActivityImg,
    CommunityImg,
    QueryImg,
    DashboaredIcon,
    DashboaredActiveIcon,
    DashboaredActiveFooterIcon,
    ContentLibraryIcon,
    ContentLibraryActiveIcon,
    CalendarIcon,
    CalendarActiveIcon,
    AttendanceIcon,
    AttendanceActiveIcon,
    SummaryIcon,
    SummaryActiveIcon,
    AssessmentIcon,
    AssessmentActiveIcon,
    AssignmentIcon,
    AssignmentActiveIcon,
    EngagementIcon,
    EngagementActiveIcon,
    PerformanceIcon,
    PerformanceActiveIcon,
    CrossIcon,
    LikeIcon,
    CommentIcon,
    LikeActiveIcon,
    UploadIcon
}
export default assets